import { z } from "zod";
import { FORM_ERROR_MESSAGES } from "@shared/constants";
import { Goal } from "@shared/models";
import { CreateGoalDto, GoalFormShape } from "@containers/Goal/interfaces";

export const validationSchema = z.object({
  name: z.string().min(1, FORM_ERROR_MESSAGES.REQUIRED).max(150, `Name ${FORM_ERROR_MESSAGES.LONG}`),
  due_date: z.string().min(1, FORM_ERROR_MESSAGES.REQUIRED),
  description: z.string().min(1, FORM_ERROR_MESSAGES.REQUIRED).max(250, `Description ${FORM_ERROR_MESSAGES.LONG}`),
  progress: z
    .number({ error: FORM_ERROR_MESSAGES.REQUIRED })
    .min(0, "progress must be greater than or equal to 0")
    .max(100, "progress must be less than or equal to 100"),
}) satisfies z.ZodType<GoalFormShape>;

export const getInitValues = (goal: Goal | null): GoalFormShape => ({
  name: goal?.name || "",
  due_date: goal?.due_date ? new Date(goal.due_date).toISOString().substring(0, 10) : "",
  description: goal?.description || "",
  progress: goal?.progress || 0,
});

export const prepareSubmitValue = (value: GoalFormShape): CreateGoalDto => ({
  name: value.name,
  due_date: new Date(String(value.due_date)),
  description: value.description,
  progress: value.progress,
});
